import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ArtifactModalComponent } from './artifact-modal.component';
import { ArtifactComponent } from './artifact.component';
import { ArtifactOneTimeMailingAddressComponent } from './artifact-one-time-mailing-address.component';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { RegenerateArtifactModalComponent } from './regenerate-artifact-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { SharedModule } from '../../shared/shared.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { MvdnowClaimAccountSharedModule } from '../../customer/mvdnow-claim-account/shared/mvdnow-claim-account-shared.module';

@NgModule({
    declarations: [
        ArtifactComponent,
        ArtifactOneTimeMailingAddressComponent,
        ArtifactModalComponent,
        RegenerateArtifactModalComponent
    ],
    imports: [
        SharedModule,
        MVMSpinnerBtnModule,
        ValidationResultsModule,
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        ReactiveFormsModule,
        DropdownModule,
        MvdnowClaimAccountSharedModule
    ],
    exports: [
        ArtifactComponent,
        ArtifactModalComponent,
        RegenerateArtifactModalComponent
    ]
})
export class ArtifactModule {
}
